export enum LoginMethod {
  PASSWORD,
  GOOGLE,
}

export {};
